// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"20494ff2","796":"4e6e203b"}[chunkId] + ".chunk.js";
};